import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-financial-home',
    templateUrl: './financial-home.component.html',
    styleUrls: ['./financial-home.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class FinancialHomeComponent implements OnInit {
    constructor() {}

    ngOnInit(): void {}
}
